import * as api from "Api";
import * as actions from "Actions";

export const fetchDynamicTableData = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      collaborator,
      client,
      clientGroup,
      squads,
      cluster,
      businessUnit,
      sortBy,
      searchWord
    } = getState().financialSheet.periodFilter;
    const {
      filter: { budgetState, year, pageSize, startPage }
    } = getState().budget.dynamicTable;
    const {
      filter: {
        clientTypes,
        clientCRMTypes,
        clientCRMGroup,
        collaboratorRole,
        isEntity
      }
    } = getState().financialSheet.periodTree;
    const {
      entityClientId: { deletedStatus, offshoreStatus, facturableStatus }
    } = getState().clients.filter;
    dispatch(
      actions.fetchDynamicTableData(
        api
          .getDynamicTableData(
            currentOrganization.id,
            client.selected,
            clientGroup.selected,
            collaborator.selected,
            collaboratorRole,
            year,
            squads.selected,
            cluster.selected,
            businessUnit.selected,
            sortBy.selected,
            clientTypes,
            clientCRMTypes,
            searchWord.searchWord,
            budgetState.join(","),
            clientCRMGroup,
            deletedStatus,
            offshoreStatus,
            facturableStatus,
            pageSize,
            startPage,
            isEntity
          )
          .then(res => res.data.data)
      )
    );
  };
};

export const updateBudgetParts = budget => (dispatch, getState) => {
  let {
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.updateBudgetParts(
      api.updateBudgetParts({
        organization: currentOrganization.id,
        budget
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/dynamic-table.js